import { render, staticRenderFns } from "./TalonarioPage.vue?vue&type=template&id=40a58c06"
import script from "./TalonarioPage.js?vue&type=script&lang=js&external"
export * from "./TalonarioPage.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports